const doc = [({"da":({"js":({"routes":({"admin":({"survey_step_elements":({"preview":({"preview_as":"Forhåndsvis som", "preview":"Forhåndsvisning"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;